// @flow

import * as types from '../ACTIONS/commonActionTypes';
import initialState from './commonInitialState';

export default function serverReducer(state = initialState.serverInfo, ourClientId:number, action) {

    switch (action.type) {
        case types.GET_FW_INFO_SUCCESS: {
            const newState = {...state}
            newState.deviceSerialNum = action.serialNum;
            newState.deviceFWVersion = action.fwVersion;
            newState.deviceWSVersion = action.wsVersion;
            newState.name = action.deviceName;
            return (newState);
        }
        case types.GOT_SERVER_INFO: {
            const newState = {...state}
            newState.initialized= true;
            newState.name = action.name;        // our name
            newState.version = action.version;  // our version
            newState.id = action.id;            // our id
            newState.config= action.config;     // added by pott - 250831

            return (newState);
        }
        case types.GET_SERVERSTATUS_SUCCESS: {
            const newState = {...state}
            newState.status = action.status; 
            newState.state = action.state;
            newState.lightColor = action.lightColor;
            newState.uptimeSecs = action.uptimeSecs;
            newState.systemTicks = action.systemTicks;
            newState.lastError = action.lastError;
            return (newState);
        }
        case types.ATTEMPT_DEVICE_RECONNECT: {
            const newState = {...state}
            newState.retryReconnect = Date.now()
            return (newState);
        }
        case types.GOT_LIGHT_UPDATE: {
            const newState = {...state}
            newState.lightColor = action.color;
            newState.lightFlash = action.flash;
            return (newState);
        }
        default:
            return(state);
    }
}

